module.exports = __webpack_public_path__ + "img/lh.43432266.jpg";